exports.order_statuses = {
    created: 'created',
    packaging: 'packaging',
    user_cancelled: 'user_cancelled',
    store_cancelled: 'store_cancelled',
    shipped: 'shipped',
    delivered: 'delivered',
    refund_progress: 'refund_progress',
    cancelled_refund: 'cancelled_refund',
    refunded: 'refunded',
}
